<template>
    <div v-wechat-title="title" style="height: 100%">
        <crud-facecade
            ref="surgery-trace-list"
            :url="url"
            :columns="columnList"
            :buttons="[]"
            dialogWidth="65%"
            :addButton="{ enabled: false, permission: 'default' }"
            :tableHeight="this.screenHeight - 260"
            :updateButton="{ enabled: false, permission: 'default' }"
            @nextStep_1="nextStep($event, 0)"
            @nextStep_2="nextStep($event, 1)"
            @printDetail="printDetail"
            @printNotice="printNotice"
            @rowClick="loadTransportNode"
            @loadSupplementView="loadSupplementView"
            style="margin-bottom: 100px"
        >
            <slot slot="filter">
                <el-col :md="8" :xl="4" class="align-left">
                    <item-input type="datearraw2" v-model="rdate"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="string" v-model="wristband" placeholder="请扫描腕带" :autofocus="true" @keyup.native.enter="scanWrist()"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="select" v-model="dic_room_id" :options="operationRoom" :clearable="true" placeholder="手术间"></item-input>
                </el-col>
                <el-col :span="4">
                    <item-input type="select" v-model="patient_status" :options="patientStatus" :clearable="true" placeholder="状态"></item-input>
                </el-col>
            </slot>
            <slot slot="filter-after">
                <el-switch v-model="isOpen" inactive-text="通知" active-value="1" inactive-value="0" @change="OpenNotice()"></el-switch>
            </slot>
            <template slot="patient_name" slot-scope="{ row }">
                <span>{{ row.patient_name }}</span
                ><span class="circle fg-red borderd" v-if="row.is_reoperation">再</span>
            </template>
        </crud-facecade>
        <el-footer style="position: absolute; bottom: 0; background: white; width: 100%; z-index: 99; margin-left: -10px; height: 100px !important">
            <CusStep :steps="transportNode">
                <div slot-scope="{ step }">
                    <font-awesome-icon :icon="['fas', 'file-alt']" v-if="step.remark" style="color: black" @click="EditDocument(step)"></font-awesome-icon>
                    <font-awesome-icon :icon="['fas', 'edit']" v-if="step.enum_record_type >= 90" style="color: black" @click="EditData(step)"></font-awesome-icon>
                    <font-awesome-icon
                        :icon="['fas', 'reply']"
                        v-if="step.enum_record_type >= 90 && permissions && permissions.findIndex(item => item.permission === `transfer:reply`) != -1"
                        style="color: black"
                        title="撤回"
                        @click="CencelData(step)"
                    ></font-awesome-icon>
                </div>
            </CusStep>
        </el-footer>
        <cus-dialog title="患者转运记录单" :visible.sync="document.dialogFormVisible" width="85%" @confirm="$refs.doc.save()" class="dialog-adverse">
            <DocFrame ref="doc" style="height: 580px" :docno="document.docno" :guid="document.docguid" :surgeryId="document.surgeryId" docname="患者转运记录单" @saved="afterDocumentSaved"></DocFrame>
        </cus-dialog>
        <cus-dialog title="补录" :visible.sync="supplement.dialogFormVisible" width="40%" @confirm="supplementEvent()">
            <div class="margin10 margin-none-h align-left">
                <span class="align-left line-height30">发生时间：</span>
                <item-input type="datetime" v-model="supplement.datadt" style="width: 200px; display: inline-block"></item-input>
            </div>
            <div class="margin10 margin-none-h align-left">
                <span class="align-left line-height30">发生事件：</span>
                <item-input type="select" v-model="supplement.event" :options="supplement.events" style="width: 200px; display: inline-block"></item-input>
            </div>
            <div class="margin10 margin-none-h align-left">
                <span class="align-right line-height30">转 运 人 ：</span>
                <item-input type="select" v-model="supplement.user" :options="this.workerList" style="width: 200px; display: inline-block"></item-input>
            </div>
        </cus-dialog>
        <cus-dialog title="事件调整" :visible.sync="editevent.dialogFormVisible" width="25%" @confirm="editEvent()">
            <div class="margin10 margin-none-h align-left">
                <span class="align-left line-height30">发生事件：</span>
                <item-input type="string" :readonly="true" v-model="editevent.event_name" style="width: 200px; display: inline-block"></item-input>
            </div>
            <div class="margin10 margin-none-h align-left">
                <span class="align-left line-height30">发生时间：</span>
                <item-input type="datetime" v-model="editevent.datadt" style="width: 200px; display: inline-block"></item-input>
            </div>
            <div class="margin10 margin-none-h align-left">
                <span class="align-right line-height30">转 运 人 ：</span>
                <item-input type="select" v-model="editevent.user" :options="this.workerList" style="width: 200px; display: inline-block"></item-input>
            </div>
        </cus-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `TransferHandover`,
    props: {

    },
    data() {
        return {
            title: `转运交接`,
            rdate: this.$moment().format(`YYYY/MM/DD`),
            url: { area: `TransferHandover`,
                baseURL: `/api/Nursing/PatientTransport`,
                get: () => {
                    this.dic_operating_ward_id = this.active_ward && this.active_ward.value.split(`_`)[1]
                    return this.loadPatientTransport()
                } },
            transportNode: [],
            dic_operating_ward_id: undefined,
            document: {// 当前打开的文书一些内容
                dialogFormVisible: false,
                docguid: ``,
                surgeryId: ``,
                docno: 323
            },
            wristband: ``,
            workerList: [],
            isOpen: sessionStorage.getItem(`isOpen`),
            count: 0,
            thisrow: {},
            allTransEvents: [],
            permissions: [],
            supplement: {
                dialogFormVisible: false,
                events: [],
                surgeryId: ``,
                event: ``,
                user: this.currentUser && this.currentUser.dic_worker_id,
                datadt: ``
            },
            editevent: {
                dialogFormVisible: false,
                event_name: ``,
                id: ``,
                surgeryId: ``,
                user: this.currentUser && this.currentUser.dic_worker_id,
                datadt: ``
            },
            dic_room_id: undefined,
            patientStatus: [],
            patient_status: undefined,
            searchList: [],
            isAutoReceive: this.$root.isAutoReceive == `1`
        }
    },
    created() {
        this.loadMessage()
        this.loadAllTransEvents()
        this.loadPermissions()
    },
    computed: {
        ...mapGetters([`active_ward`, `screenHeight`, `currentUser`]),
        operationRoom() {
            return (
                (this.active_ward &&
                    this.active_ward.operation_room &&
                    this.active_ward.operation_room.map(d => {
                        d.code = ``
                        return d
                    })) ||
                []
            )
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                isListable: false,
                isKey: true
            }, {
                type: `string`,
                prop: `patient_name`,
                label: `姓名`,
                width: `100`,
                queryable: true
            }, {
                type: `custom`,
                prop: `patient_name`,
                label: `姓名`,
                width: `100`,
                isListable: true,
                fixed: `left`
            }, {
                type: `string`,
                prop: `sex`,
                label: `性别`,
                width: `60`,
                isListable: true
            }, {
                type: `string`,
                prop: `age`,
                label: `年龄`,
                width: `60`,
                isListable: true
            }, {
                type: `string`,
                prop: `visit_no`,
                label: this.T(`transfer_handover.visit_no`),
                width: `80`,
                isListable: true
            }, {
                type: `string`,
                prop: `dic_section`,
                label: `科室`,
                width: `100`,
                isListable: true
            }, {
                type: `string`,
                prop: `dic_inpatient_section`,
                label: `病区`,
                width: `100`,
                isListable: true
            }, {
                type: `string`,
                prop: `bed_no`,
                label: `床号`,
                width: `60`,
                isListable: true
            }, {
                type: `string`,
                prop: `dic_operating_room`,
                label: `手术间`,
                width: `100`,
                // sortable: true,
                isListable: true
            }, {
                type: `string`,
                prop: `sequence`,
                label: `台次`,
                width: `80`,
                // sortable: true,
                isListable: true
            }, {
                type: `string`,
                prop: `surgeries`,
                label: `手术名称`,
                isListable: true
            }, {
                type: `string`,
                prop: `surgeon`,
                label: `主刀医生`,
                width: `80`,
                isListable: true
            }, {
                type: `string`,
                prop: `patient_status`,
                label: `状态`,
                width: `80`,
                isListable: true
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `380`,
                // fixed:"right",
                isListable: true,
                readonly: false,
                options: (that, { row }) => {
                    let r = _.filter(row.next_node, `is_transport_node`).map((d, index) => { // todo:此处特殊处理：最多监听2个按钮
                        return {
                            class: `is-plain`,
                            label: d.name,
                            icon: ``,
                            type: `primary`,
                            emit: `nextStep_${index + 1}`,
                            permission: `default`
                        }
                    })
                    return r.concat([{
                        class: `is-plain`,
                        label: `打印`,
                        icon: ``,
                        type: `primary`,
                        emit: `printDetail`,
                        permission: `default`
                    }, {
                        class: `is-plain`,
                        label: `通知单`,
                        icon: ``,
                        type: `primary`,
                        emit: `printNotice`,
                        permission: `default`
                    }, {
                        class: `is-plain`,
                        label: `补录`,
                        icon: ``,
                        type: `primary`,
                        emit: `loadSupplementView`,
                        permission: `default`
                    }])
                },
                config: {
                    align: `flex-start`
                }
            }]
        }
    },
    methods: {
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
                console.log(this.permissions)
            }).catch(e => {})
        },
        loadWorkerList() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Worker/SearchForOperatingWard?operatingWardId=${this.dic_operating_ward_id || -1}`)
                req.then(data => {
                    this.workerList = data
                    resolve(data)
                })
            })
        },
        loadAllTransEvents() {
            let req = this.myaxios.get(`/api/Nursing/PatientTransport/GetAllTransEvents`)
            req.then(data => {
                this.allTransEvents = _.filter(data, { disabled: false })

                console.log(this.allTransEvents)
            })
        },
        loadPatientTransport() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Nursing/PatientTransport/Get?date=${this.rdate}`)
                req.then(data => {
                    if (this.wristband.length > 0) {
                        data = _.filter(data, { wristband: this.wristband })
                    }
                    data = _.filter(data, d => {
                        return d.dic_operating_ward_id == this.dic_operating_ward_id
                    })
                    let r = data
                    if (r && r.length > 0 && this.transportNode.length == 0) {
                        this.loadTransportNode({ row: r[0] })
                    } else if (r.length == 0) {
                        this.transportNode = []
                    }
                    this.loadWorkerList()
                    let into = _.orderBy(r, [item => item.latest_occure_time ? 0 : 1, `latest_occure_time`, `dic_operating_room`, `sequence`, `plan_time`], [`asc`, `desc`, `asc`, `asc`, `asc`])
                    that.searchList = _.cloneDeep(into)
                    that.patientStatus = _.reduce(
                        _.groupBy(into, `patient_status`),
                        function(result, g, key) {
                            result.push({
                                label: key,
                                value: key
                            })
                            return result
                        },
                        []
                    )
                    if (that.dic_room_id) {
                        that.searchList = _.filter(that.searchList, { dic_operating_room_id: that.dic_room_id })
                    }
                    if (that.patient_status && that.patient_status != ``) {
                        that.searchList = _.filter(that.searchList, { patient_status: that.patient_status })
                    }
                    if (this.wristband.length > 0 && that.searchList && that.searchList.length == 1 && that.isAutoReceive) {
                        // 通过扫码查找到具体一条患者且开通了自动接患者流程
                        this.autoReceivePatient(that.searchList[0])
                    }
                    resolve(that.searchList)
                }).catch(e => reject(e))
            })
        },
        printDetail({ row }) {
            this.$store.dispatch(`PRINT_PDF`, { host: this.$root.DOCSERVICE_BASE,
                params: {
                    docid: this.$root.DOCUMENT.HZZY006,
                    id1: row.id,
                    objId: row.id
                } })
        },
        printDetail2(row) { // 消息提醒打印通知单
            this.$store.dispatch(`PRINT_PDF`, { host: this.$root.DOCSERVICE_BASE,
                params: {
                    docid: this.$root.DOCUMENT.PC008,
                    id1: parseInt(row.rowid),
                    objId: row.id
                } })
        },
        printNotice({ row }) { // 打印通知单
            this.$store.dispatch(`PRINT_PDF`, { host: this.$root.DOCSERVICE_BASE,
                params: {
                    docid: this.$root.DOCUMENT.PC008,
                    id1: row.id,
                    objId: row.id
                } })
        },
        autoReceivePatient(row) {
            let target = {
                row: row
            }
            let index = 0 // 接患者 通常是第一个节点
            if (row.next_node[index].code === `Send` || row.next_node[index].name == `接患者`) {
                this.sendMessage(target, index)
                this.putNextStep(target, index, ``)
                this.wristband = ``
            }
        },
        nextStep(target, index) {
            let { row } = target
            if (row.next_node[index].code === `Send`) {
                this.sendMessage(target, index)
            }
            // this.loadTransportNode(target)
            if (row.next_node[index].description) {
                this.loadDocument(target, index)
            } else {
                this.putNextStep(target, index, ``)
            }
        },
        putNextStep(target, index, remark) {
            this.sendMessage2(target, index)
            let { row } = target
            let req = this.myaxios.post(`/api/Nursing/PatientTransport/Post`, {
                // id:row.id,
                remark: remark,
                dic_event_id: row.next_node[index].id,
                biz_surgery_info_id: row.id,
                // occur_time:this.$moment().format("YYYY/MM/DD HH:mm:ss"),
                enum_record_type: 90
            })
            req.then(data => {
                this.$message.success(`操作成功`)
                this.loadTransportNode(target)
                this.$refs[`surgery-trace-list`].ReloadListData()
                this.document.dialogFormVisible = false
            })
        },
        loadDocument(target, index) {
            let { row } = target
            this.document.docno = this.$root.DOCUMENT[row.next_node[index].description]
            if (!this.document.docno) {
                this.$message.warning(`未查到相关文书，请确认患者转运的文书配置！`)
                return
            }
            this.document.docguid = `患者转运记录单_${row.id}_${this.document.docno}`
            this.document.surgeryId = row.id
            this.document.dialogFormVisible = true
            this.document.target = target
            this.document.index = index
            this.$nextTick(() => {
                this.$refs.doc.loadDocument()
            })
        },
        afterDocumentSaved(data) {
            if (this.document.target) {
                this.putNextStep(this.document.target, this.document.index, this.document.docguid)
            } else {
                this.document.dialogFormVisible = false
            }
        },
        loadTransportNode({ row }) {
            this.thisrow = row
            let req = this.myaxios.get(`/api/Nursing/PatientTransport/GetSurgeryTransport/${row.id}`)
            req.then(data => {
                this.transportNode = data && _.map(data, d => {
                    d.title = d.event_name
                    d.status = d.id > 0 ? `primary` : `info`
                    return d
                })
                if (this.transportNode && this.transportNode.length > 0) {
                    row.patient_status = this.transportNode[this.transportNode.length - 1].title
                } else {
                    row.patient_status = `已排程`
                }
                console.log(this.transportNode)
            }).catch(e => { console.log(e) })
        },
        EditDocument(step) {
            this.document.docno = this.$root.DOCUMENT[step.event_description]
            this.document.docguid = `患者转运记录单_${step.biz_surgery_info_id}_${this.document.docno}`
            this.document.surgeryId = step.biz_surgery_info_id
            this.document.dialogFormVisible = true
            this.document.target = undefined
            this.document.index = undefined
            this.$nextTick(() => {
                this.$refs.doc.loadDocument()
            })
        },
        EditData(step) {
            let upuser = this.workerList && this.workerList.find(s => s.label == step.modifier)
            this.editevent.dialogFormVisible = true
            this.editevent.event_name = step.event_name
            this.editevent.id = step.id
            this.editevent.surgeryId = step.biz_surgery_info_id
            this.editevent.datadt = step.occur_time
            this.editevent.user = upuser && upuser.value
        },
        CencelData(step) {
            console.log(step)
            let that = this
            this.$confirm(`此操作将撤回该节点, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.delete(`/api/Nursing/PatientTransport/DeleteNode/${step.id}`)
                req.then(data => {
                    that.loadTransportNode({ row: that.thisrow })
                    this.$refs[`surgery-trace-list`].ReloadListData()
                })
            }).catch(() => {})
            console.log(step)
        },
        scanWrist() {
            this.$refs[`surgery-trace-list`].ReloadListData()
        },
        OpenNotice() {
            sessionStorage.removeItem(`isOpen`)
            sessionStorage.setItem(`isOpen`, this.isOpen)
        },
        loadMessage() {
            let that = this
            let wsImpl = window.WebSocket || window.MozWebSocket
            window.ws = new wsImpl(this.$root.BoardIP)
            ws.onmessage = function(evt) {
                let data = JSON.parse(evt.data)
                if (that.active_ward.value !== data.receiver) {
                    return false
                }
                if (data.type === `HG` && data.status == 1) {
                    that.notice(data)
                    that.count += 1
                } else if (data.type === `REFRESH`) {
                    that.count += 1
                }
            }
            ws.onopen = function() {
                ws.send(`HeartBeat,患者转运Handover.vue`)
                console.log(`connection open`)
            }
            ws.onclose = function() {
                console.log(`connection closed`)
                setTimeout(function() {
                    that.loadMessage()
                }, 5000)
            }
        },
        sendMessage(target, index) {
            let r = target.row
            let msgData = `{
          "id":${index},
          "title":"${r.dic_recovery_bed || r.dic_operating_room} ${r.next_node[index].name}",
          "message":"${r.patient_name}/ ${r.sex === null ? `--` : r.sex}/${r.age == null ? `--` : r.age}/ ${r.visit_no == null ? `--` : r.visit_no}/ ${r.dic_section}/ ${r.bed_no == null ? `--` : `${r.bed_no.replace(`床`, ``)}床`}",
          "receiver":"${this.active_ward.value}",
          "type":"HG",
          "biz_surgery_info_id":"${r.biz_surgery_info_id == undefined ? r.biz_surgery_info_id : ``}",
          "rowid":"${r.id}",
          "status":"${this.isOpen}"
        }`
            let req = this.myaxios.post(`/api/Operation/BoardNotice/SendMessage?msg=${msgData}`)
            req.then(data => {
            }).catch(e => {
                console.log(e)
            })
        },
        sendMessage2(target, index) {
            let r = target.row
            let msgData = `{
          "id":${index},
          "title":"${r.dic_recovery_bed || r.dic_operating_room} ${r.next_node[index].name}",
          "message":"${r.patient_name}/ ${r.sex === null ? `--` : r.sex}/${r.age == null ? `--` : r.age}/ ${r.visit_no == null ? `--` : r.visit_no}/ ${r.dic_section}/ ${r.bed_no == null ? `--` : r.bed_no}",
          "receiver":"${this.active_ward.value}",
          "type":"REFRESH",
          "biz_surgery_info_id":"${r.biz_surgery_info_id == undefined ? r.biz_surgery_info_id : ``}",
          "rowid":"${r.id}"
        }`
            let req = this.myaxios.post(`/api/Operation/BoardNotice/SendMessage?msg=${msgData}`)
            this.myaxios.all(req).then(([data]) => {
            }).catch(e => {
                console.log(e)
            })
        },
        notice(data) {
            let that = this
            // if(this.isOpen === "1"){
            this.$notify({
                title: `${data.title}`,
                dangerouslyUseHTMLString: true,
                message: this.$createElement(`div`, null, [
                    this.$createElement(`div`, null, data.message),
                    this.$createElement(`div`, null, [this.$createElement(`button`, {
                        style: {
                            backgroundColor: this.$getThemePrimaryColor(),
                            color: `#fff`,
                            float: `right`,
                            border: `none`,
                            borderRadius: `3px`,
                            width: `60px`,
                            height: `25px`
                        },
                        on: {
                            click: function(e) {
                                that.printDetail2(data)
                            }
                        }
                    },
                    `通知单`)])
                ]),
                type: `info`,
                position: `bottom-right`,
                duration: 0
            })
        // }
        },
        loadSupplementView({ row }) {
            let req = this.myaxios.get(`/api/Nursing/PatientTransport/GetSurgeryTransport/${row.id}`)
            req.then(data => {
                this.supplement.surgeryId = row.id
                this.supplement.events = _.differenceWith(_.uniqBy(this.allTransEvents, `value`), data, function(ath, oth) {
                    return ath.value == oth.dic_event_id
                })
                this.supplement.dialogFormVisible = true
                this.supplement.datadt = this.$moment().format(`YYYY/MM/DD HH:mm`)
                this.supplement.event = this.supplement.events[0] && this.supplement.events[0].value
                this.supplement.user = this.currentUser && this.currentUser.dic_worker_id
            }).catch(e => { console.log(e) })
        },
        supplementEvent() {
            let that = this
            console.log(`that.thisrow`)
            let evt = _.find(this.allTransEvents, d => d.value == this.supplement.event)
            if (!evt) { return }
            let req = this.myaxios.post(`/api/Nursing/PatientTransport/Post`, {
                remark: evt.code ? `患者转运记录单_${this.supplement.surgeryId}_${this.$root.DOCUMENT[evt.code]}` : undefined,
                dic_event_id: evt.value,
                biz_surgery_info_id: this.supplement.surgeryId,
                occur_time: this.supplement.datadt,
                modifier: this.supplement.user,
                enum_record_type: 90
            })
            req.then(data => {
                that.supplement.dialogFormVisible = false
                that.loadTransportNode({ row: that.thisrow })
                this.$refs[`surgery-trace-list`].ReloadListData()
            })
        },
        editEvent() {
            let that = this
            console.log(this.editevent)
            let req = this.myaxios.put(`/api/Nursing/PatientTransport/Put`, {
                id: this.editevent.id,
                biz_surgery_info_id: this.editevent.surgeryId,
                occur_time: this.editevent.datadt,
                modifier: this.editevent.user
            })
            req.then(data => {
                that.editevent.dialogFormVisible = false
                that.loadTransportNode({ row: that.thisrow })
            })
        }
    },
    watch: {
        rdate: function(newUrl, oldUrl) {
            this.$refs[`surgery-trace-list`].ReloadListData()
        },
        'active_ward.value': function(newUrl, oldUrl) {
            this.$refs[`surgery-trace-list`].ReloadListData()
        },
        count: function() {
            this.$refs[`surgery-trace-list`].ReloadListData()
        },
        dic_room_id: function() {
            this.$refs[`surgery-trace-list`].ReloadListData()
        },
        patient_status: function() {
            this.$refs[`surgery-trace-list`].ReloadListData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Transfer/Handover.vue